module.exports = __webpack_public_path__ + "img/optionC.b01ba3ec.png";